export default function getFullScreen(embedCode) {
    return /data-fullscreen/.test(embedCode);
}
